import _styled from "@emotion/styled-base";
import { css } from '@emotion/core';
export var sizes = {
  '1:2': {
    name: "znp41l",
    styles: "&:after{padding-top:200%;}"
  },
  '9:16': {
    name: "16031bd",
    styles: "&:after{padding-top:177.778%;}"
  },
  '2:3': {
    name: "17p1lum",
    styles: "&:after{padding-top:150%;}"
  },
  '3:4': {
    name: "17x22n0",
    styles: "&:after{padding-top:125%;}"
  },
  '1:1': {
    name: "yfngpq",
    styles: "&:after{padding-top:100%;}"
  },
  '4:3': {
    name: "1usq3gd",
    styles: "&:after{padding-top:75%;}"
  },
  '3:2': {
    name: "g7o9ff",
    styles: "&:after{padding-top:66.667%;}"
  },
  '16:9': {
    name: "10tl0v4",
    styles: "&:after{padding-top:56.25%;}"
  },
  '2:1': {
    name: "1gydhhb",
    styles: "&:after{padding-top:50%;}"
  }
};
export var intrinsic = {
  name: "1o8azc6",
  styles: "&:after{content:'';display:block;}"
};
export var StyledImage = _styled("div", {
  target: "e12pcunl0"
})("margin-left:auto;margin-right:auto;overflow:hidden;position:relative;@media screen and (min-width:", function (props) {
  return props.theme.globalMobile;
}, "){&.--left,.--left &{margin-left:0;}&.--right,.--right &{margin-right:0;}}.flex > &{margin-left:0;margin-right:0;}img,svg{display:inline-block;position:relative;width:100%;}.cls-1{stroke:", function (props) {
  return props.theme.colors.front1;
}, ";fill:", function (props) {
  return props.theme.colors.front1;
}, ";}&.--invert{.cls-1{stroke:", function (props) {
  return props.theme.colors.front2;
}, ";fill:", function (props) {
  return props.theme.colors.front2;
}, ";}}");
export var inner = {
  name: "1t0zmeb",
  styles: "height:100%;left:0;position:absolute;top:0;width:100%;img,svg{height:100%;object-fit:cover;object-position:0;width:100%;}"
};